import React, { Component } from "react";

import colors from "../../colors";

import Slider from "./Slider";

import ReactHtmlParser from "react-html-parser";
const home =
  "<ul> <li>Inventory of glacial lakes using high resolution data&nbsp;</li> </ul> <ul> <li>Selection of critical glacial lakes using desk based approach.&nbsp;</li> </ul> <ul> <li>Prioritization of critical lakes&nbsp;</li> </ul> <ul> <li>Generation of high resolution DEM for D/S of prioritized critical lakes (15)&nbsp;</li> </ul> <ul> <li>Investigation of prioritized critical lakes and their surroundings based on high resolution DEM and data.&nbsp;</li> </ul> <ul> <li>GLOF modeling and inundation mapping using high resolution DEM</li> </ul> <p>&nbsp;</p>";

export default class GProjObjective extends Component {
  render() {
    return (
      <div
      className="cardeck_full"
     
    >
      <div className="carddeck_inner"
        style={{
        
          backgroundColor: colors.background,
        }}
      >
          <Slider />
          {/* <MDBCard style={{ width: "100%", }}>
            <MDBCardBody> */}
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div
              className="card"
              style={{ padding: "15px", width: "100%", height: "100%" }}
            >
              {/* <main style={{flexGrow: "1", width:"100%", height:"100%", flexGrow:1, flexBasis:"content", alignSelf:"bsaeline"}}>
      <div className="card"> */}
              <div className="card-body">
                <h3 className="card-title" style={{ color: "#002171" }}>
                  Glacial Lake Outburst Flood (GLOF) Risk Assessment of Glacial
                  Lakes in the Himalayan Region of Indian River Basins
                </h3>
                <hr />
                {ReactHtmlParser(home)}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
